var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import TextClickToCopy from '../TextClickToCopy.vue';
let ContactEmailRows = class ContactEmailRows extends Vue {
    constructor() {
        super(...arguments);
        this.tooltipStyle = `
    font-size:14px; background-color:#9EB3DC; min-width:180px; padding:.8rem;
  `;
    }
    validationInfo(email) {
        switch (email.validation) {
            case 'valid':
                return {
                    icon: 'icon-check-validation',
                    label: 'E-mail verificado',
                };
            case 'invalid':
                return {
                    icon: 'icon-invalid-validation',
                    label: 'E-mail inválido',
                };
            case 'maybe':
                return {
                    icon: 'icon-maybe-validation',
                    label: 'E-mail existente, mas sem resposta',
                };
            case 'unknow':
                return {
                    icon: 'icon-unknow-validation',
                    label: 'E-mail não verificado',
                };
            default:
                return {
                    icon: 'icon-email-not-requested',
                    label: this.isInSearchPage
                        ? 'Exporte esta empresa para uma lista para obter a validação'
                        : 'E-mail ainda não validado, solicite a validação para obter um resultado',
                };
        }
    }
    get isInSearchPage() {
        return window.location.href.includes('/search');
    }
};
__decorate([
    Prop({ default: () => { } })
], ContactEmailRows.prototype, "allEmails", void 0);
ContactEmailRows = __decorate([
    Component({
        components: { TextClickToCopy },
    })
], ContactEmailRows);
export default ContactEmailRows;
